import ReactECharts from 'echarts-for-react';

import type { PriceIntelTrendResponse } from '../types';

interface TrendChartProps {
  data: PriceIntelTrendResponse | null;
}

export function TrendChart({ data }: TrendChartProps) {
  if (!data || data.series.length === 0) {
    return (
      <div className="rounded-[30px] border border-dashed border-slate-300 bg-white/78 p-10 text-center text-slate-400 backdrop-blur-2xl">
        暂无趋势数据
      </div>
    );
  }

  const xAxisLabels = Array.from(
    new Set(
      data.series.flatMap((seriesItem) => seriesItem.points.map((point) => point.year_quarter)),
    ),
  ).sort();

  return (
    <div className="rounded-[30px] border border-white/80 bg-white/78 p-4 shadow-[0_18px_48px_rgba(15,23,42,0.06)] backdrop-blur-2xl">
      <ReactECharts
        notMerge
        lazyUpdate
        option={{
          tooltip: { trigger: 'axis' },
          legend: { top: 8, textStyle: { color: '#475569' } },
          grid: { left: 48, right: 24, top: 56, bottom: 32 },
          xAxis: {
            type: 'category',
            data: xAxisLabels,
            axisLine: { lineStyle: { color: '#cbd5e1' } },
            axisLabel: { color: '#64748b' },
          },
          yAxis: {
            type: 'value',
            name: 'price / sqm',
            splitLine: { lineStyle: { color: '#e2e8f0' } },
            axisLabel: { color: '#64748b' },
            nameTextStyle: { color: '#94a3b8' },
          },
          series: data.series.map((seriesItem) => ({
            type: 'line',
            smooth: true,
            name: seriesItem.competitor,
            symbolSize: 8,
            lineStyle: { width: 3 },
            areaStyle: { opacity: 0.08 },
            data: xAxisLabels.map((label) => {
              const point = seriesItem.points.find((item) => item.year_quarter === label);
              return point?.avg_price_per_sqm ?? null;
            }),
          })),
        }}
        style={{ height: 420 }}
      />
    </div>
  );
}
